import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=3a06e30c&scoped=true&"
import script from "./category-list.vue?vue&type=script&lang=js&"
export * from "./category-list.vue?vue&type=script&lang=js&"
import style0 from "./category-list.vue?vue&type=style&index=0&id=3a06e30c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06e30c",
  null
  
)

export default component.exports